var _mask, _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_8850_1360",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.11353 10.5C2.91001 6.91318 6.26776 4.5 10.1135 4.5C13.9593 4.5 17.3171 6.91321 19.1135 10.5C17.317 14.0868 13.9593 16.5 10.1135 16.5C6.26776 16.5 2.91 14.0868 1.11353 10.5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.11353 10.5L0.219406 10.0521L-0.00489235 10.5L0.219404 10.9478L1.11353 10.5ZM19.1135 10.5L20.0076 10.9479L20.2319 10.5L20.0077 10.0522L19.1135 10.5ZM2.00764 10.9478C3.66695 7.63489 6.71347 5.5 10.1135 5.5V3.5C5.82204 3.5 2.15306 6.19147 0.219406 10.0521L2.00764 10.9478ZM10.1135 5.5C13.5136 5.5 16.5601 7.63491 18.2194 10.9479L20.0077 10.0522C18.074 6.1915 14.405 3.5 10.1135 3.5V5.5ZM18.2194 10.0522C16.5601 13.3651 13.5136 15.5 10.1135 15.5V17.5C14.405 17.5 18.074 14.8085 20.0076 10.9479L18.2194 10.0522ZM10.1135 15.5C6.71348 15.5 3.66695 13.3651 2.00765 10.0522L0.219404 10.9478C2.15306 14.8085 5.82205 17.5 10.1135 17.5V15.5Z",
    fill: "#9AB400",
    mask: "url(#path-1-inside-1_8850_1360)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.1135,
    cy: 10.5,
    r: 3.5,
    stroke: "#9AB400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcView);
export default __webpack_public_path__ + "static/media/ic_view.24f0194d39c99487c48cfbf5aaee9bd1.svg";
export { ForwardRef as ReactComponent };